import { Gifs } from "@/assets/gifs";
import { useSettingsPropertiesViewModel } from "@/features/settings/viewModal/useSettingsPropertiesViewModel";
import styles from "./SettingsPropertiesPage.module.css";

export const SettingsPropertiesPage = () => {
  const {
    searchText,
    setSearchText,
    properties,
    isLoading,
    error,
    mailingTargetId,
    deletingTargetId,
    setAsMailingAddress,
    deleteProperty,
  } = useSettingsPropertiesViewModel();

  return (
    <div className={styles.page}>
      <div className={styles.topRow}>
        <h1 className={styles.title}>Your Properties</h1>

        <div className={styles.actions}>
          <div className={styles.searchBox}>
            <span aria-hidden="true">&#128269;</span>
            <input
              value={searchText}
              onChange={(event) => setSearchText(event.target.value)}
              className={styles.searchInput}
              placeholder="Search..."
            />
          </div>
          <button type="button" className={styles.filterBtn}>
            <span>Filters</span>
            <span aria-hidden="true">&#9662;</span>
          </button>
        </div>
      </div>

      <div className={styles.grid}>
        {!isLoading && !!error && (
          <article className={styles.card}>
            <div className={styles.content}>Unable to load properties. Please refresh.</div>
          </article>
        )}
        {isLoading && (
          <article className={styles.card}>
            <div className={styles.content}>Loading properties...</div>
          </article>
        )}
        {!isLoading && !error && properties.length === 0 && (
          <article className={styles.card}>
            <div className={`${styles.content} ${styles.emptyState}`}>
              <img src={Gifs.andyWalking} alt="Andy walking" className={styles.emptyGif} />
              <div>No properties found.</div>
            </div>
          </article>
        )}
        {properties.map((property) => (
          <article key={property.id} className={styles.card}>
            <img src={property.imageUrl} alt={property.name} className={styles.image} />
            <div className={styles.content}>
              <div className={styles.nameRow}>
                <h2 className={styles.name}>{property.name}</h2>
                <span className={styles.type}>{property.type}</span>
              </div>
              <div className={styles.meta}>{property.cityLine}</div>
              <div className={styles.meta}>{property.county}</div>

              <div className={styles.price}>{property.price}</div>

              <div className={styles.statusRow}>
                <span className={styles.status}>{property.status}</span>
                {property.date && <span className={styles.dateTag}>{property.date}</span>}
              </div>

              <button
                type="button"
                className={styles.viewBtn}
                onClick={() => void setAsMailingAddress(property)}
                disabled={mailingTargetId === property.id || deletingTargetId === property.id}
              >
                {mailingTargetId === property.id ? "Updating..." : "Set As Mailing Address"}
              </button>

              <button
                type="button"
                className={styles.deleteBtn}
                onClick={() => void deleteProperty(property)}
                disabled={deletingTargetId === property.id || mailingTargetId === property.id}
              >
                {deletingTargetId === property.id ? "Deleting..." : "Delete Property"}
              </button>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};
